<template>
  <a
    class="template-modal__deside"
    @click="desideTemplateQuoteMessage()"
  >{{ title }}</a>
</template>

<script>
import { eventBus } from "@/utility/event-bus";

export default {
  props: {
    title: String
  },
  methods: {
    desideTemplateQuoteMessage() {
      eventBus.decideTemplateNewsQuote();
    }
  }
};
</script>

<style scoped>
</style>
